// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__13eQO","emails":"CreateEditClinics_emails__IduLb","emailTagLabel":"CreateEditClinics_emailTagLabel__uPqGw"};